// MACHINERY V2 (Stroje) — the four fields BOTH custom-machine types carry
// (M2.7). Split out of CustomMachineFields.tsx to keep it clear of the 300-line
// cap (the ticket's split-before-new-lines rule).
//
// Spec: data package §10 rows serialNumber / productionYear /
// controlSystemBrandId / system. Reference impl: the two-column grids at
// CncForm.tsx:160 and ProductionLineForm.tsx:114 — v1 restates these four
// fields in BOTH form components; v2 states them once.
// Artboards 0803 + 0804 both end with these two rows, in this order.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";
import { UseFormReturn } from "react-hook-form";

import useTranslation from "../../../../shared/hooks/useTranslation";
import { integerRegex } from "../../../../shared/validators";
import { ChangeMachine } from "../../models/models";
import { CalendarGlyph, CpuGlyph, HashGlyph } from "../forms/FormGlyphs";
import { FormSelectOption } from "../forms/FormSelect";
import { FreeSoloRow, SelectRow, TextRow, TwoCol } from "./customMachineFieldAtoms";

export interface CustomMachineTailProps {
  form: UseFormReturn<ChangeMachine>;
  controlBrandOpts: FormSelectOption[];
  controlModelNames: string[];
  /** §10: the control-system MODEL is disabled while the brand is exactly "". */
  systemDisabled: boolean;
}

const CustomMachineTail: React.FC<CustomMachineTailProps> = ({
  form,
  controlBrandOpts,
  controlModelNames,
  systemDisabled,
}) => {
  const { translate } = useTranslation(["myMachinery", "common"]);
  const currentYear = new Date().getFullYear();
  const required = translate("common:forms.required");

  return (
    <React.Fragment>
      <TwoCol>
        <TextRow
          form={form}
          name="serialNumber"
          label={translate("myMachinery:serialNumber")}
          glyph={<HashGlyph />}
          required
          mono
          maxLength={50}
          placeholder={translate("myMachinery:v2.add.serialPlaceholder")}
          rules={{ required }}
        />
        <TextRow
          form={form}
          name="productionYear"
          label={translate("myMachinery:productionYear")}
          glyph={<CalendarGlyph />}
          mono
          maxLength={4}
          placeholder={String(currentYear)}
          rules={{
            pattern: {
              value: integerRegex,
              message: translate("myMachinery:fieldRequire4Digits"),
            },
            min: {
              value: 1900,
              message: translate("myMachinery:enterValidYearRange", { year: currentYear }),
            },
            max: {
              value: currentYear,
              message: translate("myMachinery:enterValidYearRange", { year: currentYear }),
            },
          }}
        />
      </TwoCol>

      <TwoCol>
        <SelectRow
          form={form}
          name="controlSystemBrandId"
          label={translate("myMachinery:v2.add.controlSystemBrand")}
          glyph={<CpuGlyph />}
          required
          placeholder={translate("myMachinery:chooseFromList")}
          options={controlBrandOpts}
        />
        <FreeSoloRow
          form={form}
          name="system"
          label={translate("myMachinery:v2.add.controlSystemModel")}
          glyph={<CpuGlyph />}
          required
          maxLength={50}
          placeholder={translate("myMachinery:typeOrChoose")}
          suggestions={controlModelNames}
          disabled={systemDisabled}
          rules={{ required }}
        />
      </TwoCol>
    </React.Fragment>
  );
};

export default CustomMachineTail;
